export default __webpack_public_path__ + "static/media/white-edges.153f3a47.jpg";